import { render, staticRenderFns } from "./UploadAutomatic.vue?vue&type=template&id=cbb4e07c&"
import script from "./UploadAutomatic.vue?vue&type=script&lang=js&"
export * from "./UploadAutomatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports